<router-outlet />
@if (loadingService.loading()) {
  <div
    class="fixed top-0 left-0 z-50 flex h-full w-full items-center justify-center bg-black opacity-20"
  >
    <div class="loader"></div>
  </div>
}
